export const GET_ORDER_ALERTS = 'GET_ORDER_ALERTS';
export const getOrderAlerts = () => ({
  type: GET_ORDER_ALERTS,
});

export const GET_MORE_ORDER_ALERTS = 'GET_MORE_ORDER_ALERTS';
export const getMoreOrderAlerts = (page, successResponse, failureResponse) => ({
  type: GET_MORE_ORDER_ALERTS,
  page,
  successResponse,
  failureResponse,
});
